import { Plus, Trash2 } from 'lucide-react';
import {
  Button,
  Input,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@vnetwork/ui/primitives';
import { Field } from '@vnetwork/ui/forms';
import { type InitVolume } from '@/api/opennebula';
import { SectionCard, VOLUME_TYPES, VOLUME_TYPE_LABELS } from './shared';

export { isPublicNet, NetworkCard } from './NetworkCard';
export { FirewallCard } from './FirewallCard';

/** Volumes — root disk plus extra volumes. */
export function VolumeCard({
  volumes,
  onChange,
}: {
  volumes: InitVolume[];
  onChange: (v: InitVolume[]) => void;
}) {
  const set = (i: number, p: Partial<InitVolume>) =>
    onChange(volumes.map((v, idx) => (idx === i ? { ...v, ...p } : v)));
  return (
    <SectionCard title="Volume" description="Root disk plus any extra volumes attached to the instance.">
      <div style={{ display: 'grid', gap: 'var(--vn-space-2)' }}>
        {volumes.map((v, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'flex-end', gap: 'var(--vn-space-2)', flexWrap: 'wrap' }}>
            <Field label={i === 0 ? 'Root volume' : 'Name'}>
              {(p) => <Input {...p} value={v.name} disabled={i === 0} onChange={(e) => set(i, { name: e.target.value })} style={{ width: 'min(160px, 100%)' }} />}
            </Field>
            <Field label="Size (GiB)">
              {(p) => <Input {...p} type="number" min={1} value={v.size} onChange={(e) => set(i, { size: Number(e.target.value) })} style={{ width: 'min(120px, 100%)' }} />}
            </Field>
            <Field label="Type">
              {() => (
                <Select value={v.type} onValueChange={(t) => set(i, { type: t })}>
                  <SelectTrigger style={{ width: 'min(170px, 100%)' }}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    {VOLUME_TYPES.map((t) => (
                      <SelectItem key={t} value={t}>
                        {VOLUME_TYPE_LABELS[t] ?? t}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            </Field>
            {i > 0 && (
              <Button type="button" variant="ghost" size="sm" onClick={() => onChange(volumes.filter((_, idx) => idx !== i))}>
                <Trash2 size={15} />
              </Button>
            )}
          </div>
        ))}
        <div>
          <Button
            type="button"
            variant="secondary"
            size="sm"
            startIcon={<Plus size={14} />}
            onClick={() => onChange([...volumes, { name: `data-${volumes.length}`, size: 10, type: 'hiops' }])}
          >
            Add volume
          </Button>
        </div>
      </div>
    </SectionCard>
  );
}
